import React, { useState } from "react";
import MenuData from "../MenuData";
import MenuCategories from "../MenuCategories";
import MenuDisplay from "../MenuDisplay";
import "./Menu.css";
const allCategories = ['all', ...new Set(MenuData.map((item) => item.category))];

function Menu() {
  const [menuItems, setMenuItems] = useState(MenuData);
  const [categories, setCategories] = useState(allCategories);
  const filterItems = (category) => {
    if (category === 'all') {
      setMenuItems(MenuData);
      return;
    }
    const newItems = MenuData.filter((item) => item.category === category);
    setMenuItems(newItems);
  };

  return (
    <main>
      <section className="menu section">
        <div className="title">
          <h1>our menu</h1>
          <div className="underline"></div>
        </div>
        <MenuCategories categories={categories} filterItems={filterItems} />
        <MenuDisplay items={menuItems} />
      </section>
    </main>
  );
}

export default Menu;